export const styles = {
    appbar: {
        display: 'flex',
    },
    paper: {
        marginTop: '5ch',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      },
    form_center: {
        width: '100%'
    }
  }
  export const drawerWidth = '250px'
  export const drawerClosed = 60